<section
  id="duesy-panel"
  class="duesy-panel"
  role="dialog"
  aria-modal="false"
  aria-labelledby="duesy-panel-title"
  aria-describedby="duesy-panel-subtitle"
  (keydown.escape)="onEscape($event)"
>
  <header class="duesy-panel__header">
    <div class="duesy-panel__avatar"><app-duesy-robot-icon [size]="28"></app-duesy-robot-icon></div>
    <div class="duesy-panel__titles">
      <h2 id="duesy-panel-title" class="duesy-panel__title">
        Duesy <span class="duesy-panel__online" aria-hidden="true"></span>
      </h2>
      <p id="duesy-panel-subtitle" class="duesy-panel__subtitle">Your duesPlus Support Assistant</p>
    </div>
    <div class="duesy-panel__controls">
      <button type="button" class="duesy-icon-button" aria-label="New chat" title="New chat" (click)="newChat()">
        <i class="pi pi-plus" aria-hidden="true"></i>
      </button>
      <button type="button" class="duesy-icon-button" aria-label="Minimize Duesy" title="Minimize" (click)="minimizeRequest.emit()">
        <i class="pi pi-minus" aria-hidden="true"></i>
      </button>
      <button type="button" class="duesy-icon-button" aria-label="Close Duesy" title="Close" (click)="closeRequest.emit()">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>
  </header>

  <div class="duesy-panel__context">
    <span aria-hidden="true">✦</span> Helping with <strong>{{ page.pageName }}</strong>
  </div>

  <div #scroller class="duesy-panel__body" tabindex="-1" (scroll)="onScroll()">
    <ng-container *ngIf="!state.messages.length; else conversation">
      <div class="duesy-empty">
        <div class="duesy-empty__heading">
          <div class="duesy-panel__avatar duesy-panel__avatar--small"><app-duesy-robot-icon [size]="22"></app-duesy-robot-icon></div>
          <h3>Ask Duesy. Get answers.</h3>
        </div>
        <p>Hi! I'm Duesy. I explain how to use duesPlus: where things are, what terms mean, and which training video to watch.</p>

        <div class="duesy-topics">
          <button
            *ngFor="let topic of topics"
            type="button"
            class="duesy-topic"
            [disabled]="state.sending"
            (click)="ask(topic.question)"
          >
            <i [class]="topic.icon" aria-hidden="true"></i>
            <span>{{ topic.label }}</span>
            <i class="pi pi-angle-right duesy-topic__chevron" aria-hidden="true"></i>
          </button>
        </div>

        <h4 class="duesy-suggested__title" id="duesy-suggested-title">Suggested for this page</h4>
        <ul class="duesy-suggested" aria-labelledby="duesy-suggested-title">
          <li *ngFor="let prompt of page.suggestedPrompts">
            <button type="button" class="duesy-suggested__item" [disabled]="state.sending" (click)="ask(prompt)">{{ prompt }}</button>
          </li>
        </ul>
      </div>
    </ng-container>

    <ng-template #conversation>
      <ol class="duesy-messages" aria-label="Conversation with Duesy">
        <li
          *ngFor="let message of state.messages; trackBy: trackMessage"
          class="duesy-message"
          [class.duesy-message--user]="message.role === 'user'"
          [class.duesy-message--assistant]="message.role === 'assistant'"
        >
          <ng-container *ngIf="message.role === 'user'">
            <span class="sr-only">You said:</span>
            <div class="duesy-bubble duesy-bubble--user">{{ message.content }}</div>
            <time class="duesy-time" [attr.datetime]="message.createdAt.toISOString()">{{ relativeTime(message.createdAt) }}</time>
          </ng-container>

          <ng-container *ngIf="message.role === 'assistant'">
            <span class="sr-only">Duesy said:</span>
            <div class="duesy-bubble duesy-bubble--assistant">
              <div
                *ngIf="message.status === 'streaming' && !message.content"
                class="duesy-typing"
                role="status"
                aria-label="Duesy is typing"
              >
                <span></span><span></span><span></span>
              </div>
              <div *ngIf="message.content" class="duesy-markdown" [innerHTML]="html(message)"></div>

              <div *ngIf="message.status === 'error'" class="duesy-error">
                <p>{{ message.errorMessage }}</p>
                <button *ngIf="message.retryable" type="button" class="duesy-retry" (click)="retry(message)" [disabled]="state.sending">
                  <i class="pi pi-refresh" aria-hidden="true"></i> Retry
                </button>
              </div>

              <ul *ngIf="message.sources.length" class="duesy-sources" aria-label="Sources">
                <li *ngFor="let source of message.sources">
                  <a
                    *ngIf="source.url; else plainSource"
                    class="duesy-source"
                    [href]="source.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="pi pi-play" aria-hidden="true"></i>
                    {{ source.title }}<span *ngIf="source.timestamp"> @ {{ source.timestamp }}</span>
                    <span class="sr-only">(opens training video in a new tab)</span>
                  </a>
                  <ng-template #plainSource>
                    <span class="duesy-source duesy-source--plain"><i class="pi pi-book" aria-hidden="true"></i> {{ source.title }}</span>
                  </ng-template>
                </li>
              </ul>

              <p *ngIf="message.unanswered && message.status === 'done' && contactSupportUrl" class="duesy-support">
                Still need help?
                <a [href]="contactSupportUrl" target="_blank" rel="noopener noreferrer">Contact Support</a>
              </p>
            </div>

            <div class="duesy-message__meta" *ngIf="message.status === 'done'">
              <time class="duesy-time" [attr.datetime]="message.createdAt.toISOString()">{{ relativeTime(message.createdAt) }}</time>
              <div class="duesy-feedback" *ngIf="message.id" role="group" aria-label="Rate this answer">
                <button
                  type="button"
                  class="duesy-icon-button duesy-icon-button--muted"
                  aria-label="Helpful"
                  [attr.aria-pressed]="message.rating === 'up'"
                  (click)="duesy.rate(message, 'up')"
                >
                  <i class="pi" [class.pi-thumbs-up-fill]="message.rating === 'up'" [class.pi-thumbs-up]="message.rating !== 'up'" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  class="duesy-icon-button duesy-icon-button--muted"
                  aria-label="Not helpful"
                  [attr.aria-pressed]="message.rating === 'down'"
                  (click)="duesy.rate(message, 'down')"
                >
                  <i class="pi" [class.pi-thumbs-down-fill]="message.rating === 'down'" [class.pi-thumbs-down]="message.rating !== 'down'" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </ng-container>
        </li>
      </ol>
    </ng-template>
  </div>

  <button *ngIf="hasUnseen && !autoScroll" type="button" class="duesy-jump" (click)="jumpToLatest()">
    <i class="pi pi-arrow-down" aria-hidden="true"></i> Jump to latest
  </button>

  <div class="sr-only" aria-live="polite" aria-atomic="true">{{ announcement }}</div>

  <form class="duesy-composer" (ngSubmit)="submit()">
    <label for="duesy-input" class="sr-only">Ask Duesy anything</label>
    <textarea
      #input
      id="duesy-input"
      name="draft"
      rows="1"
      placeholder="Ask Duesy anything…"
      [(ngModel)]="draft"
      [attr.maxlength]="state.maxMessageLength"
      [attr.aria-describedby]="showCounter ? 'duesy-counter' : null"
      (keydown)="onInputKeydown($event)"
    ></textarea>
    <span *ngIf="showCounter" id="duesy-counter" class="duesy-counter" aria-live="polite">{{ remaining }} characters left</span>
    <button
      *ngIf="speechSupported"
      type="button"
      class="duesy-icon-button duesy-icon-button--muted"
      [attr.aria-label]="listening ? 'Stop voice input' : 'Speak your question'"
      [attr.aria-pressed]="listening"
      (click)="toggleMic()"
    >
      <i class="pi pi-microphone" aria-hidden="true"></i>
    </button>
    <button type="submit" class="duesy-send" aria-label="Send" [disabled]="!draft.trim() || state.sending">
      <i class="pi pi-send" aria-hidden="true"></i>
    </button>
  </form>
  <p class="duesy-panel__footer">Duesy can make mistakes. Review important details.</p>
</section>
